import { COEUR_PULSE_CONTENT } from './coeurPulseContent';
import { FAPS_CONTENT } from './fapsContent';
import { P_SPRINGT_CONTENT } from './pSpringtContent';

export const TYPE_LABELS = {
  perm: 'PeRM',
  einseilrettung: 'Einseilrettung',
  'coeur-pulse': 'COEUR PULSE',
  faps: 'Prusiksystem (FAPS)',
  'p-springt': 'P_Springt',
  deep: 'DEEP (Windkraftanlage)',
};

export const EINSATZ_MENU_ITEMS = [
  { type: 'coeur-pulse', label: 'COEUR PULSE', path: '/einsatz?type=coeur-pulse' },
  { type: 'einseilrettung', label: 'Einseilrettung', path: '/einsatz?type=einseilrettung' },
  { type: 'p-springt', label: 'P_Springt', path: '/einsatz?type=p-springt' },
  { type: 'perm', label: 'PeRM', path: '/einsatz?type=perm' },
  { type: 'faps', label: 'Prusiksystem (FAPS)', path: '/einsatz?type=faps' },
  { type: 'datenaustausch', label: 'Datenaustausch', path: '/einsatz/datenaustausch' },
];

const PERM_CONTENT = {
  title: 'PERM',
  subtitle: 'Personenrettung mittels (Mobil-) Kran (PeRM)',
  source: 'Stand 01.12.2025',
  referenceDocument: {
    label: 'Original-PDF herunterladen',
    href: '/einsatz/perm/personenrettung-mittels-kran.pdf',
    filename: '2025_12_01 Personenrettung mittels Kran.pdf',
  },
  quickFacts: [],
  sections: [
    {
      id: 'allgemeine-grundsaetze',
      title: 'Allgemeine Grundsätze',
      defaultExpanded: true,
      intro:
        'Die nachfolgenden Einsatzvarianten sollen zur Anwendung kommen, wenn ein Einsatz des PAM nicht möglich ist oder Nachteile gegenüber diesen Varianten absehbar sind. Abweichungen durch den Einheitsführer Höhenrettung sind nach Lagebeurteilung möglich.',
      groups: [
        {
          title: 'Kommunikation und Kranführung',
          items: [
            'Kommunikation zwischen Kranmannschaft/Kranführer und Höhenretter sicherstellen.',
            'Krankommandos sollten ausschließlich durch den Kranführer gegeben werden.',
            'Bei Gefahr eines Kontaktes von Kranflasche oder Seilen an einer Struktur verbleibt die Kranflasche etwa 2 m oberhalb des Hindernisses.',
          ],
        },
        {
          title: 'Aufgaben Oberer Retter',
          items: [
            'Führt zusätzlich Flaschenzugmaterial mit, Service Pack obligat.',
            'Verbleibt direkt oberhalb des Hindernisses und positioniert sich idealerweise dort.',
            'Schützt Seile und Struktur vor schädlichen Einflüssen.',
            'Überwacht korrekte Position von Kranflaschen und anderweitigen Aufbauten.',
            'Informiert die Kranbesatzung, sobald Seilenden frei herabhängen.',
            'Übernimmt das Seilmanagement.',
            'Bedient Abseilgeräte.',
            'Baut Flaschenzüge auf.',
          ],
        },
        {
          title: 'Aufgaben Unterer Retter',
          items: [
            'Patientenbetreuung.',
            'Bedienung der Tragenspinne.',
            'Schützt Seile vor Beschädigungen, zum Beispiel durch Fenstersturz.',
          ],
        },
        {
          title: 'Sicherheits- und Bewegungsgrundsätze',
          items: [
            'Hebe- und Ablassvorgänge können primär durch den Kran durchgeführt werden. Im geringsten Zweifel bzgl. Sicherheit Flaschenzüge und Abseilgeräte einsetzen.',
            'Fahrbewegungen des Mobilkrans nur mit aufgezogenen Seilen.',
            'Zwei Höhenretter im System sind die Regel, um eine dauerhafte Betreuung des Patienten sicherzustellen, auch bei einer Havarie.',
            'Fensterrahmen und Regenrinnen können mit Unterbauhölzern vom HLF geschützt werden.',
            'Eine Patientensicherung entsprechend des Körpergewichtes ist obligat.',
            'Ein Gesichts- und Gehörschutz des Patienten ist sicherzustellen.',
          ],
        },
      ],
    },
    {
      id: 'einsatzvariante-perm',
      title: 'Einsatzvariante PeRM',
      defaultExpanded: true,
      media: {
        inlineLabel: null,
        inlineTitle: null,
        label: 'Bild 1',
        title: 'Grafik Einsatzvariante PeRM',
        src: '/einsatz/perm/einsatzvariante-perm.png',
        alt: 'Schematische Darstellung Einsatzvariante PeRM',
      },
      callouts: [
        {
          title: 'Schematisch nicht dargestellt',
          items: [
            'Aufhängung für die Seilsäcke',
            'Umlenkkarabiner für die Abseilgeräte',
            'Tragespinne nur schematisch dargestellt',
            'Verbindung Retter zur Trage nur schematisch dargestellt',
            'Holzbohlen zum Schutz der Struktur',
          ],
        },
      ],
    },
    {
      id: 'einsatzvariante-perm-xxl',
      title: 'Einsatzvariante PeRM XXL',
      defaultExpanded: false,
      media: {
        inlineLabel: null,
        inlineTitle: null,
        label: 'Bild 2',
        title: 'Grafik Einsatzvariante PeRM XXL',
        src: '/einsatz/perm/einsatzvariante-perm-xxl.png',
        alt: 'Schematische Darstellung Einsatzvariante PeRM XXL',
      },
      callouts: [
        {
          title: 'Schematisch nicht dargestellt',
          items: [
            'Aufhängung für die Seilsäcke',
            'Umlenkkarabiner für die Abseilgeräte',
            'Tragespinne nur schematisch dargestellt',
            'Verbindung Retter zur Trage nur schematisch dargestellt',
            'Holzbohlen zum Schutz der Struktur',
          ],
        },
      ],
    },
    {
      id: 'materialliste',
      title: 'Materialliste',
      defaultExpanded: false,
      intro:
        'Die nachfolgenden Materialien werden aus dem Materialrucksack Standard, den Service-Packs der einzelnen Höhenretter sowie dem Zusatzmaterial Kranrettung zusammengestellt und können je nach örtlichen Gegebenheiten angepasst werden.',
      groups: [
        {
          title: 'Zusatzmaterial Kranrettung',
          items: ['2 x Texora-Schlinge', '6 x Stahlkarabiner'],
        },
        {
          title: 'Materialrucksack Standard',
          items: [
            '1 x Rigging Platte',
            '1 x Doppelrolle mit Karabiner und 80 cm Schlinge',
            '2 x Clutch, jeweils aus einem Materialrucksack',
            '2 x Roller Coaster inklusive Schutzmatten oder ähnlichem',
            '2 x 120 cm Bandschlinge inklusive je 1 Karabiner für die Seilsackaufhängung',
          ],
        },
        {
          title: 'Service-Packs',
          items: [
            'Je Höhenretter 1 vollständiges Service-Pack',
            '2 x Steigklemme plus Rolle inklusive Karabiner zusätzlich für den oberen Retter',
            '2 x Rolle Petzl Spin L1 an der Tragenaufhängung beim XXL-Transport',
          ],
        },
        {
          title: 'Weiteres Material',
          items: [
            '2 x Führungsleine für die Trage als zusätzliche Hilfsseile',
            '2 x 100 m Seilsack mit insgesamt 4 Hilfsseilen',
            'Trage, Tragespinne und Patientensicherung, zum Beispiel Patientengurt oder Adipositas Gigantus',
            'Holzbohle oder ähnliches zum Schutz des Fensterrahmens vom HLF',
          ],
        },
      ],
    },
    {
      id: 'hintergrundinformationen',
      title: 'Hintergrundinformationen',
      defaultExpanded: false,
      paragraphs: [
        'Das Personenrettungsmodul bietet die Möglichkeit, einen Patienten mitsamt betreuender Person bei Havarie des eingesetzten Mobilkrans jederzeit abzulassen.',
        'Zusätzlich bietet das Modul die Option, die Personenlast mittels Flaschenzügen anzuheben, wenn beim Kranmaschinisten keine ausreichende Erfahrung oder Kenntnis vorliegt.',
        'Hierfür baut der obere Höhenretter 2 Expressflaschenzüge auf und lenkt die Zugseile mittels Doppelrolle nach unten um.',
        'Damit kann die Bodenmannschaft die Last anheben. Dadurch ist eine Rettung zusätzlich durch Fenster oder andere kleine Öffnungen möglich.',
      ],
    },
  ],
};

const EINSEILRETTUNG_CONTENT = {
  title: 'Einseilrettung',
  subtitle: 'Evakuierung mittels Einseiltechnik',
  source: 'Stand 19.06.2024',
  referenceDocument: {
    label: 'Original-PDF herunterladen',
    href: '/einsatz/einseilrettung/evakuierung-mittels-einseiltechnik.pdf',
    filename: '2024_06_19 Evakuierung mittels Einseiltechnik.pdf',
  },
  quickFacts: [],
  sections: [
    {
      id: 'beschreibung',
      title: 'Beschreibung',
      defaultExpanded: false,
      blocks: [
        {
          id: 'beschreibung-einleitung',
          paragraphs: [
            'In bestimmten Situationen kann es notwendig sein, Personen unbegleitet und nur durch ein einziges Seil gesichert zu evakuieren.',
            'Beispielhaft ist eine hohe Zahl an zu evakuierenden Personen zu nennen, für deren Evakuierung nur ein kleines Zeitfenster zur Verfügung steht, ggf. kombiniert mit einer nur kleinen Anzahl an speziellen Rettern.',
          ],
        },
        {
          id: 'beschreibung-rahmenbedingungen',
          groups: [
            {
              title: 'Mindestens erforderliche Rahmenbedingungen',
              items: [
                'Der Höhenretter ist geübt in der Anwendung der Einseiltechnik.',
                'Es liegt ein guter Seilverlauf mit keinerlei schadhaften Einflüssen auf das Seil vor.',
                'Die zu rettenden Personen sind psychisch dazu in der Lage, unbegleitet abgeseilt zu werden, z. B. ohne nervöses Spielen an Karabinern oder anderen Verschlüssen.',
              ],
            },
          ],
        },
        {
          id: 'beschreibung-abschluss',
          paragraphs: [
            'Die endgültige Entscheidung über die Anwendung der Einseiltechnik obliegt dem Einheitsführer Höhenrettung unter Würdigung aller aktuell vorliegenden Begleitumstände und nach der Durchführung einer dynamischen Gefährdungsbeurteilung.',
            'Die Entscheidung zur Anwendung der Einseiltechnik sollte im Einsatzbericht dokumentiert und begründet werden.',
            'Jeder einzelne Höhenretter ist in der Pflicht anzuzeigen, sollte er sich die Anwendung nicht zutrauen.',
          ],
        },
      ],
    },
    {
      id: 'verfahrensweise',
      title: 'Verfahrensweise',
      defaultExpanded: false,
      intro: 'Die Durchführung der Einseiltechnik unterteilt sich in mehrere Abschnitte.',
      children: [
        {
          id: 'verfahrensweise-zustieg-positionierung',
          title: '1. Zustieg & Positionierung',
          defaultExpanded: false,
          paragraphs: [
            'Der Zustieg kann nicht standardisiert werden und muss immer den Umständen entsprechend angepasst werden. In aller Regel sollte der Zustieg jedoch redundant erfolgen.',
            'Der Retter bewegt sich fortlaufend im Seil und führt Arbeiten durch. Ggf. kann nicht der gesamte Seilverlauf überblickt werden, anders als bei der Evakuierung mittels Einseiltechnik, und schadhaften Einflüssen werden übersehen. Daher ist ein redundantes Arbeiten dringend angezeigt.',
            'Im Anschluss des Zustieges sollte der Retter Zeit darauf verwenden, sich optimal zu positionieren bzw. ein ordentliches und strukturiertes Arbeitsumfeld zu schaffen.',
          ],
        },
        {
          id: 'verfahrensweise-vorbereitung-erlaeuterungen',
          title: '2. Vorbereitung der Evakuierung / Erläuterungen',
          defaultExpanded: false,
          blocks: [
            {
              id: 'vorbereitung-text',
              paragraphs: [
                'Den Personen werden Auffanggurte / Rettungsdreiecke angelegt. Evtl. provisorische Sicherungsmaßnahmen müssen vorab ergriffen werden, sollten Sicherheitseinrichtungen entfernt oder gelockert werden, um den Auffanggurt / das Rettungsdreieck anzulegen.',
                'Das Einseilsystem zur Evakuierung wird installiert und an den zu evakuierenden Personen angebracht. Es wird penibel auf die Seilführung und die Ordnung des Raums geachtet. Vor der Evakuierung wird ein 4-Augen-Check per Funk durchgeführt.',
              ],
            },
            {
              id: 'vorbereitung-grafik',
              media: {
                inlineLabel: null,
                inlineTitle: null,
                label: 'Bild 1',
                title: 'Grafik Einseilrettung',
                src: '/einsatz/einseilrettung/einsatzvariante-einseilrettung.png',
                alt: 'Schematische Darstellung Evakuierung mittels Einseiltechnik',
              },
            },
            {
              id: 'vorbereitung-erlaeuterungen',
              groups: [
                {
                  title: 'Festpunkt',
                  items: [
                    'Bei Zweifelsfreiheit ist die Nutzung eines Festpunktes legitim.',
                    'Dennoch sollten zwei Anschlagmittel genutzt werden, um übersehene Gefahrenquellen wie scharfe Kanten, Metallgrat oder ähnliche Einflüsse durch Materialüberdimensionierung zu kompensieren.',
                    'Der Einsatz eines Seilschutzes soll großzügig erfolgen.',
                    'Pro Seilschutz nur ein Anschlagmittel verwenden, um die Übersicht zu erhalten.',
                  ],
                },
                {
                  title: 'Abseilgerät',
                  items: [
                    'Bei Nutzung des I\'D am Festpunkt muss das Bremsseil mind. 2 mal umgelenkt werden.',
                    'Bei Unsicherheit bzgl. der Bremswirkung sollte ein HMS zusätzlich vor das Gerät gelegt werden.',
                    'Da die Anti-Error Klemme nur unzureichend arbeiten kann, muss eine Kurzprussik auf das Bremsseil gelegt werden.',
                    'Die Kurzprussik muss entweder am Gurt des Retters oder an einer Struktur fest angeschlagen werden.',
                    'Das Seil für die Evakuierung sollte nach Möglichkeit aus dem Seilsack auslaufen.',
                    'In Ausnahmefällen ist eine Pendelrettung möglich. Hierzu mehr unter 4. Weiterführendes Materialmanagement.',
                  ],
                },
                {
                  title: 'Personenkonnektierung',
                  items: [
                    'Die Verbindung vom Seil zum Auffanggurt / Rettungsdreieck wird mittels Trilock-Karabiner oder zwei gegenläufigen Karabinern erstellt.',
                    'Um die leichte Handhabung der Knoten zu gewährleisten und evtl. Überspringen von Knotenbildern zu vermeiden, sollte für die Erstellung der Konnektierung ein doppelter Achterknoten am Seilende und im weiteren Verlauf ein Schmetterlingsknoten genutzt werden.',
                    'Die Länge der Schmetterlingsschlaufe bzw. der Abstand des Achterknotens zum Schmetterlingsknoten sollte so gewählt werden, dass die Personen bequem hängen können, das Seil jedoch ausreichend gekürzt werden kann in dem Moment des Ausstieges.',
                    'Die Erstellung des Schmetterlingsknotens entfällt, sobald nur eine Person pro Abseilvorgang evakuiert werden soll.',
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 'verfahrensweise-evakuierung',
          title: '3. Evakuierung',
          defaultExpanded: false,
          paragraphs: [
            'Die eigentliche Evakuierung soll zügig und ohne Unterbrechungen erfolgen.',
            'Die Geschwindigkeit ist moderat zu wählen, ca. 0,5 m/sek. Eine zu hohe Geschwindigkeit kann zu einem Kontrollverlust führen.',
          ],
        },
        {
          id: 'verfahrensweise-materialmanagement',
          title: '4. Weiterführendes Materialmanagement',
          defaultExpanded: false,
          paragraphs: [
            'Nach der Evakuierung wird nicht mehr benötigtes Material vom Retter abgebaut und für die nächsten Personen genutzt.',
            'Es ist empfehlenswert, das Seil aufzuziehen und im Seilsack zu verstauen. Vor dem Aufziehen sollte die Bodenmannschaft alle Knoten aus dem Seil entfernen.',
            'Benötigtes Material für die nächste Rettung, Auffanggurt, Karabiner, Bandschlingen etc., muss über andere Wege den Retter erreichen.',
            'Bei Windstille und bei ausreichend Abstand zu baulichen Strukturen kann an dem ausgegebenen Seilende das benötigte Seil aufgezogen werden oder sogar eine Pendelrettung durchgeführt werden. Hierbei ist jedoch zu beachten, dass es zu einer vollständigen Blockade des Systems kommen kann, wenn beide Seilenden sich umeinanderwickeln.',
          ],
        },
      ],
    },
    {
      id: 'zusatzinformation',
      title: 'Zusatzinformation',
      defaultExpanded: false,
      paragraphs: [
        'Diese Veröffentlichung dient dem Höhenretter als roter Faden. Dieser rote Faden kann nicht alle möglichen Einsatzszenarien erfassen und beschreiben. Ein situationsbedingtes Abweichen ist jederzeit möglich, solange die Sicherheit aller Beteiligten auf dem gleichen Niveau gewährleistet ist.',
        'Bei Rückfragen stehen die Lehrhöhenretter jederzeit zur Verfügung.',
      ],
    },
  ],
};

const EINSATZ_CONTENT = {
  perm: PERM_CONTENT,
  einseilrettung: EINSEILRETTUNG_CONTENT,
  'coeur-pulse': COEUR_PULSE_CONTENT,
  faps: FAPS_CONTENT,
  'p-springt': P_SPRINGT_CONTENT,
};

export function getEinsatzContent(type) {
  return EINSATZ_CONTENT[type] || null;
}
